module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_8003.6bd414b6.png";